import {OrganizationAction, Organization, ADD_ORGANIZATION} from "./types";


const initialStateOrganization: Organization = {
    id:'',
    ruc:'',
    name:'',
    economicActivity:'',
    description:'',
    msCatalogueCountryId:'',
    msCatalogueCountryName:'',
    status:'',
    createdAt:''
}

export function organizationReducer(
    state = initialStateOrganization,
    action: OrganizationAction
  ): Organization {
    switch (action.type) {
      case ADD_ORGANIZATION:
        return {
          ...state,
          name: action.payload
        };
      default:
        return state;
    }
  }